import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
let pending = null;
const listeners = new Set();

const fetchSettings = () => {
  if (!pending) {
    pending = api
      .get("/site-settings")
      .then((r) => {
        cache = r.data;
        listeners.forEach((l) => l(cache));
        return cache;
      })
      .catch(() => {
        pending = null;
        return null;
      });
  }
  return pending;
};

export const setSiteSettingsCache = (data) => {
  cache = data;
  pending = Promise.resolve(data);
  listeners.forEach((l) => l(cache));
};

export const useSiteSettings = () => {
  const [settings, setSettings] = useState(cache);
  useEffect(() => {
    listeners.add(setSettings);
    if (!cache) fetchSettings();
    return () => listeners.delete(setSettings);
  }, []);
  return settings;
};
